// src/app/state/actions/user.actions.ts
import { createAction, props } from '@ngrx/store';

export const loadUserById = createAction(
  '[User] Load User By Id',
  props<{ userId: string }>()
);

export const loadUserByIdSuccess = createAction(
  '[User] Load User By Id Success',
  props<{ userId: string; userData: unknown }>()
);

export const loadUserByIdFailure = createAction(
  '[User] Load User By Id Failure',
  props<{ userId: string; error: string }>()
);

export const loadUsers = createAction(
  '[User] Load Users',
  props<{ params?: any }>()
);

export const loadUsersSuccess = createAction(
  '[User] Load Users Success',
  props<{ users: unknown[]; total: number }>()
);

export const loadUsersFailure = createAction(
  '[User] Load Users Failure',
  props<{ error: string }>()
);

export const cancelLoadUsers = createAction(
  '[User] Cancel Load Users'
);

export const updateUser = createAction(
  '[User] Update User',
  props<{ userId: string; changes: any }>()
);

export const updateUserSuccess = createAction(
  '[User] Update User Success',
  props<{ userId: string; userData: unknown }>()
);

export const updateUserFailure = createAction(
  '[User] Update User Failure',
  props<{ userId: string; error: string }>()
);

export const deleteUser = createAction(
  '[User] Delete User',
  props<{ userId: string }>()
);

export const deleteUserSuccess = createAction(
  '[User] Delete User Success',
  props<{ userId: string }>()
);

export const deleteUserFailure = createAction(
  '[User] Delete User Failure',
  props<{ userId: string; error: string }>()
);

export const loadUserByEmail = createAction(
  '[User] Load User By Email',
  props<{ email: string }>()
);

export const loadUserByEmailSuccess = createAction(
  '[User] Load User By Email Success',
  props<{ userData: unknown }>()
);

export const loadUserByEmailFailure = createAction(
  '[User] Load User By Email Failure',
  props<{ email: string; error: string }>()
);

